import React from 'react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { useFragment, graphql } from 'react-relay';
import { useIntl } from '@atlassian/jira-intl';
import { EmptyFieldText } from '@atlassian/jira-issue-empty-field-text/src/ui/index.tsx';
import type { atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView$key as AtlasProjectFragment } from '@atlassian/jira-relay/src/__generated__/atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView.graphql';
import { AtlasProjectSmartLink } from '@atlassian/jira-issue-field-atlas-project-common/src/ui/atlas-project-smart-link/index.tsx';
import messages from './messages.tsx';
import type { AtlasProjectReadViewProps } from './types.tsx';

/**
 * The AtlasProjectReadView will show a read only view of AtlasProject field.
 * @param props [AtlasProjectReadViewProps](./types.tsx)
 */
export const AtlasProjectReadView = ({ fragmentRef }: AtlasProjectReadViewProps) => {
	const { formatMessage } = useIntl();

	const { project, isLinkEditable, issue } = useFragment<AtlasProjectFragment>(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView on JiraTownsquareProjectField {
				isLinkEditable
				project {
					id @required(action: THROW)
					atlasProjectKey: key
					atlasProjectName: name
					privateProject
				}
				issue {
					id @required(action: THROW)
				}
			}
		`,
		fragmentRef,
	);

	if (!project) {
		return <EmptyFieldText emptyText={formatMessage(messages.emptyFieldText)} />;
	}

	return (
		<AtlasProjectSmartLink
			projectAri={project.id}
			projectKey={project.atlasProjectKey}
			name={project.atlasProjectName}
			isPrivate={!!project.privateProject}
			isInherited={isLinkEditable === false}
			issueAri={issue?.id}
		/>
	);
};
